
import axios from 'axios'
export default {

state:{
    text: "сияние чистого разума",
    isLoadingMsg: true,
    dialogModal: false,
    startGettingChat : false,
    page:1,
    msgCount: 0,
    displayDataMsg: [],
    selectedDialogData: [],


},
actions:{


getMsgWithParams(ctx,params){
  ctx.commit('isLoadingMsg',true)
  if(!this.state.msg.dialogModal){
    axios.post('http://'+ this.state.localhost+'/'+this.state.path+'/msg/msg_get.php', {params})
    .then(response =>{
     ctx.commit('newDisplayDataMsg',response.data)
     //this.state.displayDataMsg = response.data
    })
  }
  },


getMsg(ctx){
  axios.post('http://'+ this.state.localhost+'/'+this.state.path+'/msg/msg_get.php', {
  params:{},
  })
  .then(response =>{
   ctx.commit('newDisplayDataMsg',response.data)
   //this.state.displayDataMsg = response.data
  })

},

getChat(ctx, selectedChat){
  if(!this.state.startGettingChat){
  this.state.startGettingChat = true
  axios.post('http://'+ this.state.localhost+'/'+this.state.path+'/msg/chat_get.php', {selectedChat})
  .then(response =>{
  ctx.commit('selectedDialogData',response.data)
  this.state.startGettingChat = false
  })
  }
},

deleteChat(ctx, selectedChat){
  axios.post('http://'+ this.state.localhost+'/'+this.state.path+'/msg/chat_delete.php', {selectedChat})
},



},



mutations:{
  isLoadingMsg(state,payload){
  state.isLoadingMsg = payload
  },
  newDisplayDataMsg(state,payload){
  state.isLoadingMsg = false
  state.displayDataMsg =  payload

  },
  selectedDialogData(state,payload){
  state.selectedDialogData =  payload
  },
},


getters:{}








}
